@if(currentReport) {
  <div>

    <h1 class="center-text">
      Report <span>: {{currentReport.title}}</span>
    </h1>

    <hr class="hr-solid">

    @if(!customReport) {
      @switch(currentReportType.reportTypeName) {
        @case('Integration') {
          <app-integration-report-view
                [reportId]="currentReport.reportId"
                [currentReportToShow]="currentReport"
                [serverItems]="serverItems"
                [dataSourceTypeItems]="dataSourceTypeItems"
                [destinationEndpointItems]="destinationEndpointItems"
                [importTypeItems]="importTypeItems"
                [integrationRunTimeItems]="integrationRunTimeItems"
                >
            </app-integration-report-view>
        }
        @case('IntegrationInformation') {
          <app-integrationinfo-report-view
                [reportId]="currentReport.reportId"
                [currentReportToShow]="currentReport"
                [serverItems]="serverItems"
                [dataSourceTypeItems]="dataSourceTypeItems"
                [destinationEndpointItems]="destinationEndpointItems"
                [importTypeItems]="importTypeItems"
                [integrationRunTimeItems]="integrationRunTimeItems"
                >
            </app-integrationinfo-report-view>
        }
        @case('ClientContract') {
          <app-client-contract-report
              [reportId]="currentReport.reportId"
              [currentReportToShow]="currentReport">
            </app-client-contract-report>
        }
      }
    }

    <!-- Report Back Button -->
    <ng-container>
      <div class="report-command-button-group">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
          Go Back
        </button>
      </div>
    </ng-container>
  </div>

}
